import { apiClient } from '../../services/api';

/**
 * Get all jurisdictions
 */
export async function getJurisdictions(options = {}) {
  const params = new URLSearchParams();
  if (options.active !== undefined) params.append('active', options.active);

  const queryString = params.toString();
  const url = queryString ? `/jurisdictions?${queryString}` : '/jurisdictions';

  const response = await apiClient.get(url);
  return response.data;
}

/**
 * Get a single jurisdiction
 */
export async function getJurisdiction(code) {
  const response = await apiClient.get(`/jurisdictions/${code}`);
  return response.data;
}

/**
 * Create a jurisdiction (admin only)
 */
export async function createJurisdiction(data) {
  const response = await apiClient.post('/jurisdictions', data);
  return response.data;
}

/**
 * Update a jurisdiction (admin only)
 */
export async function updateJurisdiction(code, data) {
  const response = await apiClient.patch(`/jurisdictions/${code}`, data);
  return response.data;
}

/**
 * Delete a jurisdiction (admin only)
 */
export async function deleteJurisdiction(code) {
  const response = await apiClient.delete(`/jurisdictions/${code}`);
  return response.data;
}

export default {
  getJurisdictions,
  getJurisdiction,
  createJurisdiction,
  updateJurisdiction,
  deleteJurisdiction
};
